var map = {
	"./Analytics": 538,
	"./Analytics.js": 538,
	"./Links.html": 1217,
	"./Robots.txt": 1218,
	"./TagManager": 539,
	"./TagManager.js": 539,
	"./Wayfinder": 540,
	"./Wayfinder.js": 540,
	"./favicon.ico": 1219,
	"./google59e421ebfe8a8015.html": 1220,
	"./im.html": 1221,
	"./images/2023-og-image-klo.jpg": 1222,
	"./images/Allissue.PNG": 1223,
	"./images/Arrow-Right.PNG": 1224,
	"./images/CYB2.jpg": 1225,
	"./images/Fullissue.PNG": 1226,
	"./images/Home-Help-mousehover.png": 1227,
	"./images/Home-Help.png": 1228,
	"./images/Home-search-mousehover.png": 1229,
	"./images/Home-search.png": 1230,
	"./images/List-Style.PNG": 1231,
	"./images/NextArticle.PNG": 1232,
	"./images/Outlook-WK.jpg": 1233,
	"./images/Plus.PNG": 1234,
	"./images/Rss-Default.png": 1235,
	"./images/Rss-Hover.png": 1236,
	"./images/WK.PNG": 1237,
	"./images/WkFooter.PNG": 1238,
	"./images/ajax-loader.gif": 1239,
	"./images/amex.png": 1240,
	"./images/arrow_down.png": 1241,
	"./images/arrow_up.png": 1242,
	"./images/authorSpotlight/adamLiberman.jpg": 1243,
	"./images/authorSpotlight/alanChristopherNeal.jpg": 1244,
	"./images/authorSpotlight/alastairSutton.jpg": 1245,
	"./images/authorSpotlight/albertJanVanDenBerg.jpg": 1246,
	"./images/authorSpotlight/alexanderRust.jpg": 1247,
	"./images/authorSpotlight/andreAlen.jpg": 1248,
	"./images/authorSpotlight/andreaBiondi.jpg": 1249,
	"./images/authorSpotlight/andreasRZiegler.jpg": 1250,
	"./images/authorSpotlight/author-Esme.png": 1251,
	"./images/authorSpotlight/author-roger.png": 1252,
	"./images/authorSpotlight/author-spot1.png": 1253,
	"./images/authorSpotlight/berntHugenholtz.jpg": 1254,
	"./images/authorSpotlight/bobWessels.jpg": 1255,
	"./images/authorSpotlight/edwinVermulst.jpg": 1256,
	"./images/authorSpotlight/ericSchwartz.jpg": 1257,
	"./images/authorSpotlight/frankEijsvogels.jpg": 1258,
	"./images/authorSpotlight/frankHendrickx.jpg": 1259,
	"./images/authorSpotlight/garyBorn.jpg": 1260,
	"./images/authorSpotlight/jeanFrancoisBelis.jpg": 1261,
	"./images/authorSpotlight/jeffreyLSnyder.jpg": 1262,
	"./images/authorSpotlight/jochenBuling.jpg": 1263,
	"./images/authorSpotlight/jochenBühling.jpg": 1264,
	"./images/authorSpotlight/jochenB├╝hling.jpg": 1265,
	"./images/authorSpotlight/johannMuller.jpg": 1266,
	"./images/authorSpotlight/johnBalfour.jpg": 1267,
	"./images/authorSpotlight/jonathanSLux.jpg": 1268,
	"./images/authorSpotlight/klausPeterBerger.jpg": 1269,
	"./images/authorSpotlight/lucieGuibault.jpg": 1270,
	"./images/authorSpotlight/manfredWeiss.jpg": 1271,
	"./images/authorSpotlight/michaelHeimert.jpg": 1272,
	"./images/authorSpotlight/nadjaAlexander.jpg": 1273,
	"./images/authorSpotlight/nunoPiresDeCarvalho.jpg": 1274,
	"./images/authorSpotlight/peterChrocziel.jpg": 1275,
	"./images/authorSpotlight/peterFCBegg.jpg": 1276,
	"./images/authorSpotlight/rikTorfs.jpg": 1277,
	"./images/authorSpotlight/ritaDeLaFeria.jpg": 1278,
	"./images/authorSpotlight/robVernout.jpg": 1279,
	"./images/authorSpotlight/russellELevine.jpg": 1280,
	"./images/authorSpotlight/silkeHeinz.jpg": 1281,
	"./images/authorSpotlight/silviaFazio.jpg": 1282,
	"./images/authorSpotlight/steefBartman.jpg": 1283,
	"./images/authorSpotlight/stefaanVanDenBogaert.jpg": 1284,
	"./images/authorSpotlight/stefanKroll.jpg": 1285,
	"./images/authorSpotlight/stefanSchmid.jpg": 1286,
	"./images/authorSpotlight/tugrulAnsay.jpg": 1287,
	"./images/authorSpotlight/verenaVonBomhard.jpg": 1288,
	"./images/authorSpotlight/vincentVerouden.jpg": 1289,
	"./images/authorSpotlight/willemHoyngs.jpg": 1290,
	"./images/authorSpotlight/yvesDerains.jpg": 1291,
	"./images/banner-image-lg.jpeg": 1292,
	"./images/captcha.png": 1293,
	"./images/card code.png": 1294,
	"./images/cart-down.svg": 1295,
	"./images/cart.png": 1296,
	"./images/check.png": 1297,
	"./images/csv.png": 1298,
	"./images/email-mouseover.png": 1299,
	"./images/email.png": 1300,
	"./images/etoc-mouseover.png": 1301,
	"./images/etoc.png": 1302,
	"./images/export-csv-Grey.svg": 1303,
	"./images/export-csv-dafault.svg": 1304,
	"./images/export-csv-default.svg": 1305,
	"./images/facebook.png": 1306,
	"./images/facebook_mouseover.png": 1307,
	"./images/green-arrow.png": 1308,
	"./images/green-tick.svg": 1309,
	"./images/linked_in.png": 1310,
	"./images/linkedin_mousover.png": 1311,
	"./images/login.png": 1312,
	"./images/mastercard.png": 1313,
	"./images/pdf-icon-no-text.svg": 1314,
	"./images/pdf-icon-with-text.svg": 1315,
	"./images/question_mark_mouseover.png": 1316,
	"./images/questionmark_default.png": 1317,
	"./images/rss-mouseover.png": 1318,
	"./images/rss.png": 1319,
	"./images/search question - MouseHover.png": 1320,
	"./images/search question.png": 1321,
	"./images/search_button.png": 1322,
	"./images/search_button_Mousehover.png": 1323,
	"./images/search_mouseover.png": 1324,
	"./images/twitter-mouseover.png": 1325,
	"./images/twitter.png": 1326,
	"./images/visa.png": 1327,
	"./images/white-small.svg": 1328,
	"./index.html": 1329,
	"./manifest": 541,
	"./manifest.json": 541,
	"./maxsizeimages/Allissue.PNG": 1330,
	"./maxsizeimages/Arrow-Right.PNG": 1331,
	"./maxsizeimages/Fullissue.PNG": 1332,
	"./maxsizeimages/Home-Help-mousehover.png": 1333,
	"./maxsizeimages/Home-Help.png": 1334,
	"./maxsizeimages/Home-search-mousehover.png": 1335,
	"./maxsizeimages/Home-search.png": 1336,
	"./maxsizeimages/List-Style.PNG": 1337,
	"./maxsizeimages/NextArticle.PNG": 1338,
	"./maxsizeimages/Outlook-WK.jpg": 1339,
	"./maxsizeimages/Plus.PNG": 1340,
	"./maxsizeimages/Rss-Default.png": 1341,
	"./maxsizeimages/Rss-Hover.png": 1342,
	"./maxsizeimages/WK.PNG": 1343,
	"./maxsizeimages/WkFooter.PNG": 1344,
	"./maxsizeimages/ajax-loader.gif": 1345,
	"./maxsizeimages/amex.png": 1346,
	"./maxsizeimages/arrow_down.png": 1347,
	"./maxsizeimages/arrow_up.png": 1348,
	"./maxsizeimages/authorSpotlight/adamLiberman.jpg": 1349,
	"./maxsizeimages/authorSpotlight/alanChristopherNeal.jpg": 1350,
	"./maxsizeimages/authorSpotlight/alastairSutton.jpg": 1351,
	"./maxsizeimages/authorSpotlight/albertJanVanDenBerg.jpg": 1352,
	"./maxsizeimages/authorSpotlight/alexanderRust.jpg": 1353,
	"./maxsizeimages/authorSpotlight/andreAlen.jpg": 1354,
	"./maxsizeimages/authorSpotlight/andreaBiondi.jpg": 1355,
	"./maxsizeimages/authorSpotlight/andreasRZiegler.jpg": 1356,
	"./maxsizeimages/authorSpotlight/author-Esme.png": 1357,
	"./maxsizeimages/authorSpotlight/author-roger.png": 1358,
	"./maxsizeimages/authorSpotlight/author-spot1.png": 1359,
	"./maxsizeimages/authorSpotlight/berntHugenholtz.jpg": 1360,
	"./maxsizeimages/authorSpotlight/bobWessels.jpg": 1361,
	"./maxsizeimages/authorSpotlight/edwinVermulst.jpg": 1362,
	"./maxsizeimages/authorSpotlight/ericSchwartz.jpg": 1363,
	"./maxsizeimages/authorSpotlight/frankEijsvogels.jpg": 1364,
	"./maxsizeimages/authorSpotlight/frankHendrickx.jpg": 1365,
	"./maxsizeimages/authorSpotlight/garyBorn.jpg": 1366,
	"./maxsizeimages/authorSpotlight/jeanFrancoisBelis.jpg": 1367,
	"./maxsizeimages/authorSpotlight/jeffreyLSnyder.jpg": 1368,
	"./maxsizeimages/authorSpotlight/jochenBühling.jpg": 1369,
	"./maxsizeimages/authorSpotlight/johannMuller.jpg": 1370,
	"./maxsizeimages/authorSpotlight/johnBalfour.jpg": 1371,
	"./maxsizeimages/authorSpotlight/jonathanSLux.jpg": 1372,
	"./maxsizeimages/authorSpotlight/klausPeterBerger.jpg": 1373,
	"./maxsizeimages/authorSpotlight/lucieGuibault.jpg": 1374,
	"./maxsizeimages/authorSpotlight/manfredWeiss.jpg": 1375,
	"./maxsizeimages/authorSpotlight/michaelHeimert.jpg": 1376,
	"./maxsizeimages/authorSpotlight/nadjaAlexander.jpg": 1377,
	"./maxsizeimages/authorSpotlight/nunoPiresDeCarvalho.jpg": 1378,
	"./maxsizeimages/authorSpotlight/peterChrocziel.jpg": 1379,
	"./maxsizeimages/authorSpotlight/peterFCBegg.jpg": 1380,
	"./maxsizeimages/authorSpotlight/rikTorfs.jpg": 1381,
	"./maxsizeimages/authorSpotlight/ritaDeLaFeria.jpg": 1382,
	"./maxsizeimages/authorSpotlight/robVernout.jpg": 1383,
	"./maxsizeimages/authorSpotlight/russellELevine.jpg": 1384,
	"./maxsizeimages/authorSpotlight/silkeHeinz.jpg": 1385,
	"./maxsizeimages/authorSpotlight/silviaFazio.jpg": 1386,
	"./maxsizeimages/authorSpotlight/steefBartman.jpg": 1387,
	"./maxsizeimages/authorSpotlight/stefaanVanDenBogaert.jpg": 1388,
	"./maxsizeimages/authorSpotlight/stefanKroll.jpg": 1389,
	"./maxsizeimages/authorSpotlight/stefanSchmid.jpg": 1390,
	"./maxsizeimages/authorSpotlight/tugrulAnsay.jpg": 1391,
	"./maxsizeimages/authorSpotlight/verenaVonBomhard.jpg": 1392,
	"./maxsizeimages/authorSpotlight/vincentVerouden.jpg": 1393,
	"./maxsizeimages/authorSpotlight/willemHoyngs.jpg": 1394,
	"./maxsizeimages/authorSpotlight/yvesDerains.jpg": 1395,
	"./maxsizeimages/banner-image-lg.jpeg": 1396,
	"./maxsizeimages/books/ADR.JPG": 1397,
	"./maxsizeimages/books/AIAJ.jpg": 1398,
	"./maxsizeimages/books/AILA.jpg": 1399,
	"./maxsizeimages/books/AMDM.JPG": 1400,
	"./maxsizeimages/books/ASAB.jpg": 1401,
	"./maxsizeimages/books/BARBIT.JPG": 1402,
	"./maxsizeimages/books/BCDR.jpg": 1403,
	"./maxsizeimages/books/BRA.JPG": 1404,
	"./maxsizeimages/books/BULA.jpg": 1405,
	"./maxsizeimages/books/Banking.png": 1406,
	"./maxsizeimages/books/CAM.jpg": 1407,
	"./maxsizeimages/books/CIVI.jpg": 1408,
	"./maxsizeimages/books/CIVI.png": 1409,
	"./maxsizeimages/books/CMP.jpg": 1410,
	"./maxsizeimages/books/COLA.JPG": 1411,
	"./maxsizeimages/books/COMM.jpg": 1412,
	"./maxsizeimages/books/CONS.jpg": 1413,
	"./maxsizeimages/books/CONT.jpg": 1414,
	"./maxsizeimages/books/CORP.jpg": 1415,
	"./maxsizeimages/books/CRIM.jpg": 1416,
	"./maxsizeimages/books/CYB.jpg": 1417,
	"./maxsizeimages/books/CivilPro.png": 1418,
	"./maxsizeimages/books/Commercial.png": 1419,
	"./maxsizeimages/books/Competition.png": 1420,
	"./maxsizeimages/books/EAL.jpg": 1421,
	"./maxsizeimages/books/ECTA.jpg": 1422,
	"./maxsizeimages/books/ECTAX.jpg": 1423,
	"./maxsizeimages/books/EEELR.jpg": 1424,
	"./maxsizeimages/books/EELR.jpg": 1425,
	"./maxsizeimages/books/EERR.jpg": 1426,
	"./maxsizeimages/books/EFJ.jpg": 1427,
	"./maxsizeimages/books/EICLIT.jpg": 1428,
	"./maxsizeimages/books/ENER.jpg": 1429,
	"./maxsizeimages/books/ENVI.jpg": 1430,
	"./maxsizeimages/books/ERPL.jpg": 1431,
	"./maxsizeimages/books/EUCL.jpg": 1432,
	"./maxsizeimages/books/EUCM.jpg": 1433,
	"./maxsizeimages/books/EULR.jpg": 1434,
	"./maxsizeimages/books/EURO.jpg": 1435,
	"./maxsizeimages/books/Energy-Competition.png": 1436,
	"./maxsizeimages/books/Energy.png": 1437,
	"./maxsizeimages/books/EuCML.jpg": 1438,
	"./maxsizeimages/books/European-Union.png": 1439,
	"./maxsizeimages/books/FAMI.jpg": 1440,
	"./maxsizeimages/books/GPLR.JPG": 1441,
	"./maxsizeimages/books/GTCJ.jpg": 1442,
	"./maxsizeimages/books/IBT.jpg": 1443,
	"./maxsizeimages/books/IEADA.jpg": 1444,
	"./maxsizeimages/books/IELL.jpg": 1445,
	"./maxsizeimages/books/IGO.jpg": 1446,
	"./maxsizeimages/books/IJCL.jpg": 1447,
	"./maxsizeimages/books/ILEL.jpg": 1448,
	"./maxsizeimages/books/INSU.jpg": 1449,
	"./maxsizeimages/books/IPRO.jpg": 1450,
	"./maxsizeimages/books/JOIA.jpg": 1451,
	"./maxsizeimages/books/JournalOfWorldTrade.png": 1452,
	"./maxsizeimages/books/LEIE.jpg": 1453,
	"./maxsizeimages/books/LL_9789065449054.jpg": 1454,
	"./maxsizeimages/books/Latest-update1.png": 1455,
	"./maxsizeimages/books/Law.PNG": 1456,
	"./maxsizeimages/books/MCO.jpg": 1457,
	"./maxsizeimages/books/MEDA.jpg": 1458,
	"./maxsizeimages/books/MEDI.jpg": 1459,
	"./maxsizeimages/books/MIGR.jpg": 1460,
	"./maxsizeimages/books/MLH.PNG": 1461,
	"./maxsizeimages/books/MLH.jpg": 1462,
	"./maxsizeimages/books/MaritimeLaw.PNG": 1463,
	"./maxsizeimages/books/PRIL.jpg": 1464,
	"./maxsizeimages/books/PROP.jpg": 1465,
	"./maxsizeimages/books/RBA.jpg": 1466,
	"./maxsizeimages/books/RELI.jpg": 1467,
	"./maxsizeimages/books/RLVR.JPG": 1468,
	"./maxsizeimages/books/SOCS.jpg": 1469,
	"./maxsizeimages/books/SPORT.jpg": 1470,
	"./maxsizeimages/books/TAXI.jpg": 1471,
	"./maxsizeimages/books/TORT.jpg": 1472,
	"./maxsizeimages/books/TRAD.jpg": 1473,
	"./maxsizeimages/books/TRAN.jpg": 1474,
	"./maxsizeimages/books/Transport-law.png": 1475,
	"./maxsizeimages/books/WOCO.jpg": 1476,
	"./maxsizeimages/books/WTAM.jpg": 1477,
	"./maxsizeimages/books/author-Esme.png": 1478,
	"./maxsizeimages/books/author-roger.png": 1479,
	"./maxsizeimages/books/author-spot1.png": 1480,
	"./maxsizeimages/books/blank.png": 1481,
	"./maxsizeimages/books/common-market-law.png": 1482,
	"./maxsizeimages/books/corporate.PNG": 1483,
	"./maxsizeimages/books/corporatecomm.PNG": 1484,
	"./maxsizeimages/books/encyclopedia.PNG": 1485,
	"./maxsizeimages/books/transport.png": 1486,
	"./maxsizeimages/card code.png": 1487,
	"./maxsizeimages/cart.png": 1488,
	"./maxsizeimages/check.png": 1489,
	"./maxsizeimages/csv.png": 1490,
	"./maxsizeimages/email-mouseover.png": 1491,
	"./maxsizeimages/email.png": 1492,
	"./maxsizeimages/etoc-mouseover.png": 1493,
	"./maxsizeimages/etoc.png": 1494,
	"./maxsizeimages/facebook.png": 1495,
	"./maxsizeimages/facebook_mouseover.png": 1496,
	"./maxsizeimages/green-arrow.png": 1497,
	"./maxsizeimages/linked_in.png": 1498,
	"./maxsizeimages/linkedin_mousover.png": 1499,
	"./maxsizeimages/login.png": 1500,
	"./maxsizeimages/mastercard.png": 1501,
	"./maxsizeimages/pdf-icon-no-text.svg": 1502,
	"./maxsizeimages/pdf-icon-with-text.svg": 1503,
	"./maxsizeimages/question_mark_mouseover.png": 1504,
	"./maxsizeimages/questionmark_default.png": 1505,
	"./maxsizeimages/rss-mouseover.png": 1506,
	"./maxsizeimages/rss.png": 1507,
	"./maxsizeimages/search question - MouseHover.png": 1508,
	"./maxsizeimages/search question.png": 1509,
	"./maxsizeimages/search_button.png": 1510,
	"./maxsizeimages/search_button_Mousehover.png": 1511,
	"./maxsizeimages/search_mouseover.png": 1512,
	"./maxsizeimages/twitter-mouseover.png": 1513,
	"./maxsizeimages/twitter.png": 1514,
	"./maxsizeimages/visa.png": 1515,
	"./siqpagetag": 542,
	"./siqpagetag.js": 542,
	"./subscriber_journals.xml": 1516,
	"./subscribers.xml": 1517
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 300;


//////////////////
// WEBPACK FOOTER
// ./public ^\.\/.*$
// module id = 300
// module chunks = 1